// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__s0hyU","label":"LabeledBox_label__LD0kg"};